'use client';

import IconButton from 'src/components/primitives/IconButton/IconButton';
import { Share } from '@drift-labs/icons';
import { PnlBreakdownTooltip } from 'src/components/Tooltip/PnlBreakdownTooltip';
import { signDependentValue } from 'src/utils/signDependentValue';
import { PositionHistoryRowData } from '../types';

interface PnlCellProps {
	row: PositionHistoryRowData;
	onShareClick: () => void;
}

export function PnlCell({ row, onShareClick }: PnlCellProps) {
	const { pnl, pnlNotional, positionPnlNotional, feesAndFundingNotional } = row;

	return (
		<PnlBreakdownTooltip
			pnl={pnl}
			pnlNotional={pnlNotional}
			positionPnlNotional={positionPnlNotional}
			feesAndFundingNotional={feesAndFundingNotional}
		>
			<div className="inline-flex items-center gap-1">
				<div className="flex cursor-pointer flex-col">
					<span
						className={signDependentValue(pnl, {
							positive: 'text-text-positive-green-button',
							negative: 'text-text-negative-red-button',
							zero: '',
						})}
					>
						{pnl > 0 && <span className="inline-block w-1" />}
						{pnlNotional}
					</span>
				</div>
				<IconButton
					size="md"
					variant="tertiary"
					onClick={(e) => {
						e.stopPropagation();
						onShareClick();
					}}
					icon={Share}
				/>
			</div>
		</PnlBreakdownTooltip>
	);
}
